import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import IdlingConsumptionBasicInformationResource from './resource/IdlingConsumptionBasicInformationResource';
import {
  clearIdlingConsumptionObservation,
  getIdlingConsumptionObservation,
} from '../../../../actions';
import { IDLING_CONSUMPTION_PATH } from '../../../../config/paths';
import IdlingConsumptionToolbar from './IdlingConsumptionToolbar';

export const IdlingConsumptionObservation = ({
  breadcrumbs,
  dispatchClearIdlingConsumptionObservation,
  dispatchGetIdlingConsumptionObservation,
  match: {
    params: { id: idlingConsumptionObservationId },
  },
  loading,
  idlingConsumptionObservation,
}) => {
  useLayoutEffect(() => {
    dispatchGetIdlingConsumptionObservation({ idlingConsumptionObservationId });

    return () => dispatchClearIdlingConsumptionObservation();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (idlingConsumptionObservation.isEmpty())
    content = <NoDataResource returnPage={IDLING_CONSUMPTION_PATH} />;
  else {
    const idlingConsumptionObservationJson =
      idlingConsumptionObservation.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <IdlingConsumptionBasicInformationResource
          {...idlingConsumptionObservationJson}
        />
      </>
    );

    toolbar = (
      <IdlingConsumptionToolbar
        idlingConsumptionObservationId={idlingConsumptionObservationJson.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Control de Consumo por Ralentí"
      content={content}
    />
  );
};

IdlingConsumptionObservation.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearIdlingConsumptionObservation: PropTypes.func.isRequired,
  dispatchGetIdlingConsumptionObservation: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  idlingConsumptionObservation: PropTypes.instanceOf(Immutable.Map).isRequired,
};

IdlingConsumptionObservation.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearIdlingConsumptionObservation: clearIdlingConsumptionObservation,
  dispatchGetIdlingConsumptionObservation: getIdlingConsumptionObservation,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Control de Consumos por Ralentí',
      href: IDLING_CONSUMPTION_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  idlingConsumptionObservation: TrafficUnit.IdlingConsumption.getIn([
    'current',
    'content',
  ]),
  loading: !TrafficUnit.IdlingConsumption.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IdlingConsumptionObservation);
